import React from 'react';

interface FeatureItem {
  heading: string;
  _metadata?: { uid: string };
  image: { url: string } | null;
  image_fit?: string;
  body: string;
  buttons: unknown[];
  unlock_image_height?: boolean;
}

interface CmsPrescriptionBlockBlueData {
  name?: string;
  component?: string;
  features?: FeatureItem[];
  _metadata?: { uid: string };
}

interface CmsPrescriptionBlockBlueProps {
  data: CmsPrescriptionBlockBlueData;
}

export const CmsPrescriptionBlockBlue: React.FC<CmsPrescriptionBlockBlueProps> = ({ data }) => {
  const features = data.features ?? [];

  if (features.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col items-center w-full bg-blue-0 py-800 px-500 gap-500">
      {data.name && (
        <h2
          className="text-heading-200 font-bold leading-heading text-center text-blue-1000 m-0"
          style={{
            letterSpacing: '-0.96px',
            fontFeatureSettings: "'liga' off",
          }}
        >
          {data.name}
        </h2>
      )}

      <div className="flex justify-center items-start gap-200 w-full px-500 self-stretch">
        {features.map((feature) => (
          <div
            key={feature._metadata?.uid ?? feature.heading}
            className="flex flex-col items-center text-center flex-1 gap-50"
          >
            <span
              className="text-heading-400 font-bold leading-heading text-blue-1000 pb-200"
              style={{
                letterSpacing: '-1.92px',
                fontFeatureSettings: "'liga' off",
              }}
            >
              {feature.heading}
            </span>

            {feature.body && (
              <div
                className=" [&>h6]:!text-blue-1000 [&>h6]:text-heading-125 [&>h6]:font-bold [&>h6]:leading-heading [&>h6]:m-0 [&>h6]:pb-100 [&>p]:!text-blue-1000 [&>p]:text-body-100 [&>p]:font-medium [&>p]:leading-body [&>p]:m-0"
                style={{
                  textAlign: 'center',
                  fontFeatureSettings: "'liga' off",
                }}
                dangerouslySetInnerHTML={{
                  __html: feature.body,
                }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CmsPrescriptionBlockBlue;
